import React from "react";
import { UseFormRegisterReturn } from "react-hook-form/dist/types/form";
import classnames from "classnames";
import { FieldError } from "react-hook-form";

export interface FormInputProps {
  registerReturn: UseFormRegisterReturn;
  placeholder?: string;
  error: FieldError | undefined;
  type: "textbox" | "checkbox" | "file" | "number";
  disabled: boolean;
}

export const FormInput: React.FC<FormInputProps> = ({
  registerReturn,
  placeholder,
  error,
  type,
  disabled,
}) => {
  return type === "checkbox" ? (
    <div>
      <div className="form-check mb-2">
        <label className="form-check-label">
          <input
            type={type}
            className="form-check-input form-check-input--light"
            disabled={disabled}
            {...registerReturn}
          />
          {placeholder}
        </label>
      </div>
      {error && (
        <span className="Form__Element__ValidationError">{error.message}</span>
      )}
    </div>
  ) : (
    <div
      className={classnames("Form__Element", "FormTextbox", {
        ValidationFail: !!error,
      })}
    >
      <input
        className={classnames("FormTextbox__Input")}
        placeholder={placeholder}
        type={type}
        disabled={disabled}
        {...registerReturn}
      />
      {error && (
        <span className="Form__Element__ValidationError">{error.message}</span>
      )}
    </div>
  );
};
